module.exports = __webpack_public_path__ + "media/sfx_click_4.b851effe.wav";